import { render, staticRenderFns } from "./QuoteFormHeader.vue?vue&type=template&id=80efece2"
import script from "./QuoteFormHeader.vue?vue&type=script&lang=js"
export * from "./QuoteFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports